<template>
  <div id="app">
    <router-view />
    <div class="global-loading" v-show="isShowLoading">
      <Spin size="large"></Spin>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "App",
  data() {
    return {
      keepAliveData: ["manage"],
    };
  },
  computed: {
    ...mapState(["isShowLoading", "token"]),
  },
  mounted() {
    if (this.token || window.localStorage.getItem("zhi_token")) {
      this.$Apis.getMenuData().then((res) => {
        if (res.code == 200) {
          var menuItems = [];
          menuItems.length = res.data.length;
          for (let i = 0; i < menuItems.length; i++) {
            let data = res.data[i];
            menuItems[i] = {};
            if (data.children.length == 0) {
              menuItems[i].name = data.path;
            }
            menuItems[i].type = data.icon;
            menuItems[i].text = data.name;
            menuItems[i].id = data.id;

            if (data.children.length > 0) {
              menuItems[i].children = [];
              for (let j = 0; j < data.children.length; j++) {
                menuItems[i].children.push({
                  type: data.children[j].icon,
                  id: data.children[j].id,
                  name: data.children[j].path,
                  text: data.children[j].name,
                });
              }
            }
          }
          localStorage.setItem("ToMenuitems", "");
          localStorage.setItem("ToMenuitems", JSON.stringify(menuItems));
          this.$store.commit("setMenus", menuItems);
          let id = "";
          menuItems.map((res) => {
            if (res.children && res.children.length > 0) {
              res.children.filter((item) => {
                if (item.name == "userList") {
                  id = item.id;
                }
              });
            } else {
              id = res.id
              // console.log(res)
              // res.map((item) => {
              //   if (item.name == "userList") {
              //     id = item.id;
              //   }
              // });
            }
          });
          this.$router.push({ path: this.redirect || "/" });
        }
      });
    }
  },
};
</script>

<style>
body {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
li,
ul,
p,
div,
body,
html,
table {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html,
body {
  height: 100%;
  overflow: hidden;
}
li {
  list-style: none;
}
#app {
  height: 100%;
}
.home-content {
  padding: 10px 25px;
  border-radius: 5px;
  background: #fff;
}
/* loading */
.global-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
input::-webkit-inner-spin-button{
  -webkit-appearance: none !important;
}
input::-webkit-outer-spin-button{
  -webkit-appearance: none !important;
}
input[type=number]{
  -moz-appearance: textfield;
}
.viewer-transition {
  z-index: 10000000000000000 !important;
}

</style>
